export const Logo = ({ light = false, className = "" }) => (
  <span className={`inline-flex items-center gap-2.5 ${className}`}>
    <svg viewBox="0 0 64 64" className="h-9 w-9 shrink-0" aria-hidden="true">
      <rect width="64" height="64" rx="16" fill={light ? "#F1EBE1" : "#9A8A72"} />
      <path d="M32 10c-9 7-14 16-12 30 9-2 16-9 18-19 1-4 0-8-6-11z" fill={light ? "#9A8A72" : "#FAF8F5"} />
      <path d="M32 54c9-7 14-16 12-30-9 2-16 9-18 19-1 4 0 8 6 11z" fill="#7A6B55" />
    </svg>
    <span className="flex flex-col leading-none">
      <span className={`font-serif text-2xl font-semibold tracking-tight ${light ? "text-cream" : "text-ink"}`}>Biovital</span>
      <span className={`text-[9px] uppercase tracking-[0.32em] ${light ? "text-cream/60" : "text-muted"}`}>Centro Estetico</span>
    </span>
  </span>
);
